import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Slide, Snackbar } from '@mui/material'

const AlertBar = () => {
  const dispatch = useDispatch()
  const { message, status, visible } = useSelector((state) => state.toast)

  const handleClose = () => dispatch({ type: 'REMOVE_TOAST' })

  return visible ? (
    <Snackbar
      className="!z-[999999]"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={() => handleClose()}
      open={visible}
      autoHideDuration={5000}
      TransitionComponent={(props) => <Slide {...props} direction="left" />}
    >
      <Alert onClose={() => handleClose()} color={status}>
        {message}
      </Alert>
    </Snackbar>
  ) : (
    <></>
  )
}

export default AlertBar
